import * as actions from 'actions';

const INITIAL_STATE = {
  text: '',
  emoji: null,
  isSubmitting: false
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.JOURNAL_CREATION_CHANGE: {
      return {
        ...state,
        ...action.updates
      };
    }

    case actions.JOURNAL_ENTRY_CREATE: {
      return {
        ...state,
        isSubmitting: true
      };
    }

    case actions.JOURNAL_ENTRY_CREATE_SUCCESS: {
      return {
        ...INITIAL_STATE
      };
    }

    case actions.JOURNAL_ENTRY_CREATE_ERROR: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/journal/creation/reducer.js
 **/